import { create } from 'zustand';

import { NOTIFICATION_PAGE_SIZE, type NotificationRead } from './notifications';

interface NotificationsQueryState {
  read: NotificationRead;
  page: number;
  pageSize: number;
  setRead: (read: NotificationRead) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

const defaults: Pick<NotificationsQueryState, 'read' | 'page' | 'pageSize'> = {
  read: 'all',
  page: 1,
  pageSize: NOTIFICATION_PAGE_SIZE,
};

export const useNotificationsStore = create<NotificationsQueryState>((set) => ({
  ...defaults,

  setRead: (read) => set({ read, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),

  reset: () => set(defaults),
}));
